import moment from 'moment'

const checkIsSameMonthYear = (value) => moment().isSame(value, 'month') && moment().isSame(value, 'year')

export default checkIsSameMonthYear
